export default __webpack_public_path__ + "c7a60dc6f16fe08b74febda2364d7c63.png";